module.exports = __webpack_public_path__ + "static/hospaitality&tourism-42eb8288a7bc57cb6e2da33a68387739.png";